import keywordTrackerApi from '@/app/KeywordTracker/api/keywordTrackerApi';

const locationsApi = keywordTrackerApi.injectEndpoints({
  endpoints: build => ({
    getLocationsForSelect: build.query<unknown, void>({
      query: () => '/keyword_tracker/v2/locations/for_select'
    })
  })
});

export const { useGetLocationsForSelectQuery } = locationsApi;
export default locationsApi;
